import { render, staticRenderFns } from "./payment-success-failed.vue?vue&type=template&id=14785410&scoped=true&"
import script from "./payment-success-failed.vue?vue&type=script&lang=js&"
export * from "./payment-success-failed.vue?vue&type=script&lang=js&"
import style0 from "./payment-success-failed.vue?vue&type=style&index=0&id=14785410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14785410",
  null
  
)

export default component.exports